define('AwaLabs.Store.Main.Shopping.EntryPoint', [
    'Store.Login.LoadingCart.View',
    'Store.EntryPoint',
    'Store.ProductDetailsPage.EntryPoint',
    'Store.Cart.EntryPoint',
    'Store.Item.EntryPoint',
    'Store.SearchSpring.EntryPoint',
    'Store.Profile.EntryPoint',
    'Store.Selector.EntryPoint',
    'Store.Facets.EntryPoint',
    'Store.ItemRelations.EntryPoint',
    'Store.Session.EntryPoint',
    'Store.HandlebarsHelper.EntryPoint',
    'ProductLine.RemoveStoreFromURL'
], function AwaLabsStoreMainShopping(
    StoreLoginLoadingCartView,
    StoreEntryPoint,
    ProductDetailsPageEntryPoint,
    CartEntryPoint,
    ItemEntryPoint,
    SearchSpringEntryPoint,
    ProfileEntryPoint,
    SelectorEntryPoint,
    FacetsEntryPoint,
    ItemRelationsEntryPoint,
    StoreSessionEntryPoint
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            StoreEntryPoint.mountToApp(application);
            ProductDetailsPageEntryPoint.mountToApp(application);
            ProfileEntryPoint.mountToApp(application);
            ItemEntryPoint.mountToApp(application);
            SearchSpringEntryPoint.mountToApp(application);
            CartEntryPoint.mountToApp(application);
            SelectorEntryPoint.mountToApp(application);
            FacetsEntryPoint.mountToApp(application);
            StoreSessionEntryPoint.mountToApp(application);
            ItemRelationsEntryPoint.mountToApp(application);

            var pageTypeComponent = application.getComponent('PageType');

            pageTypeComponent.registerPageType({
                name: 'login_loadcart',
                routes: ['loaditems'],
                view: StoreLoginLoadingCartView,

            });
        }
    };
});
